import { Component, OnDestroy, OnInit } from '@angular/core';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { DatePipe } from '@angular/common';
import { PdfService } from '@app/services/pdf/pdf.service';
import { CSVDataService } from '@app/export/CSVDataService';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-debiteringslista',
  templateUrl: './debiteringslista.component.html',
  styleUrls: ['./debiteringslista.component.css']
})
export class DebiteringslistaComponent implements OnInit, OnDestroy {
  charginglist;
  items: MenuItem[];
  showSpinner = false;
  subscriptions: Subscription[] = [];
  form;
  
  constructor(private fb: FormBuilder, private institutionService: InstitutionsService, private pdfService: PdfService, private datePipe: DatePipe) { }

  ngOnInit() {
    this.form = this.fb.group({
      breakDate: [null, '']
    });
  
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }];
    //  this.search();
  }

  search() {
   this.showSpinner = true;

    this.subscriptions.push(this.institutionService.GetChargingList(this.datePipe.transform(this.form.get('breakDate').value, 'yyyy-MM-dd')).subscribe(response => {
      if (response) {
        this.charginglist = response;
        this.showSpinner = false;
      }
    }));
  }

  generatePdf() {
    const data = document.getElementById('contentToConvert');
    this.pdfService.captureScreen(data, 'l',null);
  }

  exportToCSV() {


    let firstrow = 'Antalet medlemmar i respektive institution ' + this.datePipe.transform(this.form.get('breakDate').value, 'yyyy-MM-dd') + '\n\n';
    firstrow += 'Typ;Nummer;Namn;Antal medlemmar';
    const datum = this.datePipe.transform(new Date(), 'yy-MM-dd');
    const filnamn = 'Debiteringslista_' + datum;
    CSVDataService.exportToCsv(filnamn + '.csv', this.charginglist, firstrow);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }
}
